import React, { Component } from "react";
import Contact from "./Contact.js";
import { Link } from "react-router-dom";
export default class Footer extends Component {
  render() {
    const id = window.location.pathname;
    return (
      <div>
        {id !== "/contact" && <Contact />}
        <footer className="footer">
          <div className="footer-nav has-text-centered">
            <Link to="/page/privacy-policy">Privacy Policy</Link>
          </div>
          <div className="content has-text-centered">
            <p>© {new Date().getFullYear()} OnCourse All Rights Reserved.</p>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js